export default "__VITE_PUBLIC_ASSET__2fb4b8ce__"